module.exports = __webpack_public_path__ + "static/media/icon_buffering_grey.68be165a.svg";